// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import L from 'leaflet';

myw.Circle = L.Circle.extend({
    //simpler (less accurate) version of L.Circle to avoid issues with small radius

    _project() {
        const map = this._map;
        const crs = map.options.crs;

        const latlng2 = crs.unproject(crs.project(this._latlng).subtract([this._mRadius, 0]));

        this._point = map.latLngToLayerPoint(this._latlng);
        this._radius = this._point.x - map.latLngToLayerPoint(latlng2).x;

        this._updateBounds();
    }
});

export default myw.Circle;
